// removed by extract-text-webpack-plugin
module.exports = {"root":"terms-and-conditions-popup--root--1JwGfhO3","container":"terms-and-conditions-popup--container--ubHbTXwn","button":"terms-and-conditions-popup--button--1tivvVpR"};


//////////////////
// WEBPACK FOOTER
// ./components/terms-and-conditions-popup/styles.css
// module id = ./components/terms-and-conditions-popup/styles.css
// module chunks = 0